import { createGridLayout, createGridItem } from "../../../../store/global/gridlayout";
export const bookingReportsStates = {
    bookingReportsArtistReport: {}    
};